<div id="cu-workflow-progress-wrapper" class="bl-width--100">
  <div id="cu-progress-container" class="bl-bg-color--white bl-overflow--hidden bl-padding-x--16 bl-padding-x-lg--40">
    <!-- Progress bar, product icon, toggle -->
    <div class="bl-display--flex bl-align-items--center bl-max-width--1280 bl-padding-top--8 bl-margin-x--auto">
      <!-- questions on this? see comments in dx-product-image component -->
      <dx-product-image
        [icon]="progressBarData?.groupIcon"
        *ngIf="progressBarData?.productName && progressBarData?.flowType"
        size="36px"
        [product]="progressBarData.productName"
        [flowType]="flowType"
        class="bl-display--flex bl-margin-right--16"
      >
      </dx-product-image>
      <!-- Progress bar (churro style) with header -->
      <figure id="progress-figure" class="bl-display--block bl-padding-x--0 bl-margin-bottom--8 bl-flex--auto">
        <figcaption *ngIf="title" id="progress-fig-caption" class="bl-display--flex bl-align-items--center">
          <span [attr.data-automation-id]="'application-progress-bar'" class="bl-text-style--secondary-text-2 bl-flex--auto bl-white-space--normal">{{
            title
          }}</span>
          <span class="bl-text-style--secondary-text-1">{{ completionPercent }}</span>
        </figcaption>
        <div class="churro-fig-wrapper">
          <svg id="churro-fig" width="100%" class="svg-chart" height="100%" [attr.aria-label]="completionPercent + ' Completed'" role="img">
            <title id="progress-title">{{ title }}</title>
            <rect height="10px" width="100%" rx="4px" fill="#D5DEE3" role="presentation"></rect>
            <rect />
            <rect id="churro-progress" height="10px" rx="4px" fill="#13CE66" role="presentation"></rect>
            <rect />
          </svg>
        </div>
      </figure>
      <!-- Toggle -->
      <ng-container *ngIf="progressBarData?.isDataAvailable">
        <button
          id="progress-product-detail-toggle"
          (click)="toggleLoanDetailsAccordion(loanDetailsAccordion)"
          aria-controls="progress-product-detail"
          [attr.aria-label]="productDetailsExpanded ? 'Hide' : 'Show' + ' loan details'"
        ></button>
        <i
          id="progress-product-detail-icon"
          class="bl-font-color--silver cu-icon--24 bl-padding-left--8 bl-margin-x--auto bl-display--block"
          [ngClass]="productDetailsExpanded ? 'cu-angle-up' : 'cu-angle-down'"
        >
        </i>
      </ng-container>
    </div>

    <!-- Progress footer text -->
    <p
      *ngIf="footer && footer.length !== 0"
      class="bl-text-style--secondary-text-1 bl-max-width--1280 bl-margin-x--auto bl-margin-top--8 bl-margin-bottom--0 bl-padding-x--8"
    >
      {{ footer }}
    </p>

    <!-- Progress loan details accordion -->
    <ea-accordion
      #loanDetailsAccordion
      [defaultExpanded]="false"
      controllerPosition="none"
      class="bl-display--block bl-max-width--tablet-width bl-margin-x--auto"
      [class.bl-display--none]="!progressBarData.isDataAvailable"
      [class.bl-padding-bottom--16]="loanDetailsAccordion.isOpen"
      id="progress-product-detail"
    >
      <p *ngIf="progressBarData.loanGroupName" class="bl-text-style--caption bl-text-align--center bl-margin-top--8">
        {{ progressBarData.loanGroupDisplayName }}
      </p>
      <p *ngIf="progressBarData.loanProductName" class="bl-text-style--secondary-text-2 bl-margin-top--8 bl-margin-bottom--4">
        {{ progressBarData.loanProductName }}
      </p>
      <section
        *ngIf="progressBarData.loanPurpose"
        class="bl-display--flex bl-align-items--center bl-padding-y--8"
        [class.bl-border-bottom]="progressBarData.requestedLoanAmount"
      >
        <p class="bl-text-style--secondary-text-1 bl-flex--auto bl-margin--0">{{ 'workflow-progress/loan-purpose-label' | dictionary }}</p>
        <p class="bl-text-style--secondary-text-2 bl-margin-left--8 bl-margin--0">{{ progressBarData.loanPurpose }}</p>
      </section>
      <section
        *ngIf="progressBarData.requestedLoanAmount"
        class="bl-display--flex bl-align-items--center bl-padding-y--8"
        [class.bl-border-bottom]="progressBarData.loanTerm"
      >
        <p class="bl-text-style--secondary-text-1 bl-flex--auto bl-margin--0">
          {{ 'workflow-progress/requested-amount-label' | dictionary }}
        </p>
        <p class="bl-text-style--secondary-text-2 bl-margin-left--8 bl-margin--0">
          {{ progressBarData.requestedLoanAmount | currency : 'USD' : 'symbol' : '1.2-2' }}
        </p>
      </section>
      <section
        *ngIf="progressBarData.loanTerm"
        class="bl-display--flex bl-align-items--center bl-padding-y--8"
        [class.bl-border-bottom]="progressBarData.downPayment"
      >
        <p class="bl-text-style--secondary-text-1 bl-flex--auto bl-margin--0">{{ 'workflow-progress/loan-term-label' | dictionary }}</p>
        <p class="bl-text-style--secondary-text-2 bl-margin-left--8 bl-margin--0">
          {{ progressBarData.loanTerm }} {{ 'workflow-progress/loan-term-period' | dictionary }}
        </p>
      </section>
      <section *ngIf="progressBarData.downPayment" class="bl-display--flex bl-align-items--center bl-padding-y--8">
        <p class="bl-text-style--secondary-text-1 bl-flex--auto bl-margin--0">{{ 'workflow-progress/down-payment-label' | dictionary }}</p>
        <p class="bl-text-style--secondary-text-2 bl-margin-left--8 bl-margin--0">
          {{ progressBarData.downPayment | currency : 'USD' : 'symbol' : '1.2-2' }}
        </p>
      </section>
    </ea-accordion>
  </div>
</div>
